import { Helmet } from 'react-helmet-async'
import type { Product } from 'src/components/restructure/product/types/product'
import { buildItemListJsonLd } from 'src/utils/buildItemListJsonLd'

type ItemListJsonLdProps = {
  products?: Product[] | null
  siteUrl?: string | null
  pageUrl?: string | null
  name?: string | null
  description?: string | null
  currentPage?: number | null
  itemsPerPage?: number | null
}

export function ItemListJsonLd({
  products,
  siteUrl,
  pageUrl,
  name,
  description,
  currentPage,
  itemsPerPage,
}: ItemListJsonLdProps) {
  const jsonLd = buildItemListJsonLd({
    products,
    siteUrl,
    pageUrl,
    name,
    description,
    currentPage,
    itemsPerPage,
  })

  if (!jsonLd) {
    return null
  }

  return (
    <Helmet>
      <script type="application/ld+json">{JSON.stringify(jsonLd)}</script>
    </Helmet>
  )
}
